import React, { createContext, useContext } from 'react';
import Keycloak from 'keycloak-js';
import ApiService from './ApiService';

const ApiServiceContext = createContext<ApiService | null>(null);

export const ApiServiceProvider = ({ keycloak, children }: { keycloak: Keycloak, children: React.ReactNode }) => {
  const apiService = new ApiService(keycloak);
  return (
    <ApiServiceContext.Provider value={apiService}>
      {children}
    </ApiServiceContext.Provider>
  );
};

export const useApiService = () => {
  const context = useContext(ApiServiceContext);
  if (!context) {
    throw new Error('useApiService must be used within an ApiServiceProvider');
  }
  return context;
};
